import * as React from "react";
import { useField } from "informedv4";
import { TagsInput } from "react-tag-input-component";
import { replaceDotsWithHyphens } from "../../misc/Helpers/StringHelper";
// todo migrate
// import "../../styling/vitalograph/components/_custom-inputs.scss"

interface TagsProps {
    name: string;
    field: string;
    placeholder?: string;
    helper?: string;
}

export const Tags = ({ field, name, placeholder = "enter tags", helper = "press enter to add new tag" }: TagsProps) => {
    const { fieldState, fieldApi } = useField({ name: name });
    const { value } = fieldState;
    const { setValue } = fieldApi;

    return (
        <>
            <TagsInput
                value={value as string[]}
                data-automationid={replaceDotsWithHyphens(field)}
                onChange={v => setValue(v)}
                name={name}
                placeHolder={placeholder}
            />
            <em>{helper}</em>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError() as string}</span> : null}
        </>
    );
};
